import { render, staticRenderFns } from "./questionnaireAnswer.vue?vue&type=template&id=51659280&"
import script from "./questionnaireAnswer.vue?vue&type=script&lang=js&"
export * from "./questionnaireAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports